"use client";

import { useState } from "react";
import toast from "react-hot-toast";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        toast.error(data.error || "Failed to send message");
        return;
      }
      toast.success("Message sent successfully");
      setForm({ name: "", email: "", subject: "", message: "" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="2xl:px-6 xl:px-5 lg:px-4 md:px-4 px-4 py-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <span className="mb-4 inline-block rounded-full border border-[rgba(245,158,11,0.25)] bg-[rgba(245,158,11,0.1)] px-4 py-1.5 text-xs font-medium text-accent-amber sm:text-sm">
            Contact
          </span>
          <h2 className="font-display mb-3 text-[clamp(28px,5vw,52px)] leading-tight text-text-primary">
            Get in <span className="text-ember">Touch</span>
          </h2>
          <p className="mx-auto max-w-[560px] text-sm text-text-muted sm:text-base">
            Need help or have a question? Send us a message and the team will get back to you.
          </p>
        </div>
        <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-bg-card p-6 lg:p-8">
          <h3 className="font-display text-2xl text-text-primary">Contact Us</h3>
          <p className="mt-2 text-sm text-text-muted">Fill in the form and we will respond shortly.</p>
          <form
            name="contact"
            data-netlify="true"
            onSubmit={onSubmit}
            className="mt-6 space-y-3"
          >
            <input type="hidden" name="form-name" value="contact" />
            <input
              name="name"
              value={form.name}
              onChange={(e) => setForm((s) => ({ ...s, name: e.target.value }))}
              placeholder="Your name"
              className="w-full rounded-lg border border-border bg-bg-secondary px-4 py-2.5 text-text-primary"
              required
            />
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((s) => ({ ...s, email: e.target.value }))}
              placeholder="Your email"
              className="w-full rounded-lg border border-border bg-bg-secondary px-4 py-2.5 text-text-primary"
              required
            />
            <input
              value={form.subject}
              onChange={(e) => setForm((s) => ({ ...s, subject: e.target.value }))}
              placeholder="Subject (optional)"
              className="w-full rounded-lg border border-border bg-bg-secondary px-4 py-2.5 text-text-primary"
            />
            <textarea
              rows={5}
              value={form.message}
              onChange={(e) => setForm((s) => ({ ...s, message: e.target.value }))}
              placeholder="Your message"
              className="w-full rounded-lg border border-border bg-bg-secondary px-4 py-2.5 text-text-primary"
              required
            />
            <button
              type="submit"
              disabled={submitting}
              className="rounded-lg bg-linear-to-r from-amber-500 to-orange-600 px-5 py-2.5 font-semibold text-black disabled:opacity-60"
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
